import type { Dispatch } from "@reduxjs/toolkit";
// eslint-disable-next-line no-restricted-imports -- This file defines the typed hooks that should be used instead
import { useDispatch, useSelector } from "react-redux";

import { mobileAppActions } from "./actions";
import { MobileAppActions, MobileAppState } from "./types";

/**
 * Pre-typed `useSelector` hook for use throughout the mobile app.
 * Uses Redux Toolkit's `.withTypes()` pattern for better type inference.
 * Knows about the full State shape including RTK slices.
 *
 * @example
 * const toasts = useMobileAppSelector(state => state.toasts.toasts);
 */
export const useMobileAppSelector = useSelector.withTypes<MobileAppState>();

/**
 * Pre-typed hook that provides both dispatch and all mobile actions (commons + mobile-specific) in one call.
 * Returns [dispatch, actions] tuple following useState pattern.
 *
 * @example
 * const [dispatch, actions] = useMobileAppDispatcher();
 * dispatch(actions.toasts.showToast({ title: "Hello" }));
 * dispatch(actions.mobileApp.setHasEnteredThroughDeepLink(true));
 */
export const useMobileAppDispatcher = () => {
  const dispatch = useDispatch<Dispatch<MobileAppActions>>();
  return [dispatch, mobileAppActions] as const;
};
